import { Stack, Typography } from "@mui/material";
import { SECTION_SIZES } from "../../../../constants";
import { SelectSectionButton } from "../../../shared/ui";
import shallow from "zustand/shallow";
import { SectionWidth } from "../../../../shared";
import { memo } from "react";
import AddOffsetSectionButton from "../AddOffsetSectionButton/addOffsetSectionButton";
import { NomenklatureBlock } from "./NomenklatureBlock";
import { useShelvingStore } from "../../../../store/useShelvingStore";
import { useStoreSystem } from "../../../../store";
import { getWallLineVertices } from "../../../SceneObjects/ButtonsScene/utils";
import { getCameraPositionToMiddleLine, getTargetPositionToMiddleLine } from "../../../../store/helpers";
import {AutofillButton} from "./AutofillButton";

//TODO сильно тут не ковырял, я не уверен что тут нужны memo, useCallback, useEffect
export const SectionsPanel = memo(() => {
    const { addSectionInShelf } = useShelvingStore((state) => ({
        addSectionInShelf: state.addSectionInShelving,
    }), shallow);
    const { currentSide, setSystemProperties } = useStoreSystem(state => ({
        currentSide: state.currentSide,
        setSystemProperties: state.setSystemProperties,
    }), shallow);

    const onSelectSection = (value: SectionWidth, isIndent = false) => {
        addSectionInShelf(value, isIndent);
        const lineVertices = getWallLineVertices(currentSide);
        setSystemProperties([
            { name: 'targetZoom', value: 'wall' },
            { name: 'cameraPosition', value: getCameraPositionToMiddleLine(lineVertices) },
            { name: 'targetCameraPosition', value: getTargetPositionToMiddleLine(lineVertices) }
        ]);

    };

    return (
        <Stack direction={"row"} gap={6}>
            <Stack gap={1}>
                <Typography color={"primary.main"} fontWeight={700}>
                    ДОБАВИТЬ СЕКЦИИ И ОТСТУПЫ:
                </Typography>
                <Stack direction={"row"} gap={2.5}>
                    {SECTION_SIZES.map((size) => (
                        <SelectSectionButton key={size} onClick={() => onSelectSection(size)}>
                            Добавить секцию Ширина {size} мм
                        </SelectSectionButton>
                    ))}
                </Stack>
                <Stack direction={"row"} gap={2.5}>
                    <AddOffsetSectionButton />
                    <AutofillButton />
                </Stack>
            </Stack>
            {/*//FIXME обратить внимание, может NomenklatureBlock не на месте*/}
            <NomenklatureBlock />
        </Stack>
    );
})
